import Cookies from '../../../lib/cookies';
import { isBrowser } from '../../../lib/utils';

const inbound = 'INBOUND_FLIGHTS';
const outbound = 'OUTBOUND_FLIGHTS';
const passengerDetails = 'PASSENGER_DETAILS';
const flightReservationStatus = 'FLIGHT_RESERVATION_STATUS';

const FIFTEEN_MINUTES = 900000;

/**
 * Session is used during the flight purchase process.
 * The data is stored in the session storage, and is retrieved when in use.
 */
class Session {
  constructor() {
    this.storage = isBrowser() ? sessionStorage : {};
    this.flightsReserveCookie = new Cookies(flightReservationStatus);
  }

  /**
   * start the session
   * reserve the flight for fifteen minutes
   */
  start() {
    // deleting previous stale session states
    this.end();

    this.flightsReserveCookie.set(1, FIFTEEN_MINUTES);
  }

  /**
   *
   * @param {Object} flight
   * set the inbound flights to the session storage
   */
  setInbound(flight) {
    this.storage.setItem(inbound, JSON.stringify(flight));
  }

  /**
   *
   * @param {Object} flight
   * set the outbound flights to the session storage
   */
  setOutbound(flight) {
    this.storage.setItem(outbound, JSON.stringify(flight));
  }

  /**
   * get the inbound flight from the session storage.
   */
  getInbound() {
    return this._get(inbound);
  }

  /**
   * get the outbound flight from the session storage.
   */
  getOutbound() {
    return this._get(outbound);
  }

  /**
   * get the passenger details from the session storage.
   */
  getPassengerDetails() {
    return this._get(passengerDetails);
  }

  /**
   * @param {string} key
   * get the value of the key from the session
   */
  _get(key) {
    return JSON.parse(this.storage.getItem(key));
  }

  /**
   * clear the data from session storage
   */
  _clearAll() {
    this.storage.clear();
  }

  /**
   * check whether the session has expired or not.
   */
  hasExpired() {
    return !this.getOutbound() || this.flightsReserveCookie.hasExpired();
  }

  /**
   * end the session by clearing the flight reservation cookies
   * and clearing the session storage
   */
  end() {
    this.flightsReserveCookie.delete();
    this._clearAll();
  }
}

const FlightSession = new Session();
export default FlightSession;



// WEBPACK FOOTER //
// ./src/screens/Flights/Common/FlightSession.js